import { render } from "./ABTestingConfig.vue?vue&type=template&id=5f98386e&scoped=true"
import script from "./ABTestingConfig.vue?vue&type=script&lang=js"
export * from "./ABTestingConfig.vue?vue&type=script&lang=js"

import "./ABTestingConfig.vue?vue&type=style&index=0&id=5f98386e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98386e"]])

export default __exports__